import { UpdateStrategyType } from '@ekkogmbh/apisdk';
import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { UpdaterProfileManagementContent } from './Components/UpdaterProfileManagementContent';
import { CompartmentGeneratorProvider } from 'src/CompartmentManagement/Providers/CompartmentGeneratorProvider';

export const resolveStrategyName = (type: UpdateStrategyType): string => {
  switch (type) {
    case UpdateStrategyType.MANUAL:
      return 'Manual';
    case UpdateStrategyType.REGEX_SCAN:
      return 'Regex Scan';
    case UpdateStrategyType.CLEARING:
      return 'Clearing';
  }
};

export const UpdaterProfileManagement = (): React.JSX.Element => (
  <Page title="Updater Profiles" accessKey={'updaterProfiles'} isSearchable={true}>
    <CompartmentGeneratorProvider>
      <UpdaterProfileManagementContent />
    </CompartmentGeneratorProvider>
  </Page>
);
